/** Quick-pick hours offered under the ETA time input. */
export const HOUR_PRESETS = [9, 12, 15, 18, 21] as const;

/** Highest selectable hour (24-hour clock). */
export const MAX_HOUR = 23;

/** Default hour seeded when an ETA has no time yet. */
export const DEFAULT_HOUR = 9;

/** Furthest out an admin may set a delivery ETA — matches the BE's
 *  domain.MaxETAHorizon (6 weeks from now). */
export const MAX_WEEKS_AHEAD = 6;
